import React, { useEffect, useMemo } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import CustomerManagementList from "../../../Screens/Customers/CustomerManagementList";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import "../../../styles/admin-panel.scss";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  LineController,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  fetchDashboardDataRequest,
  fetchVendorDashboardDataRequest,
} from "../../../redux/Dashboard/DashboardAction";
import { useDispatch, useSelector } from "react-redux";
import { fetchVendorInvoicesRequest } from "../../../redux/Invoice/InvoiceAction";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const VendorDashBoard = () => {
  const dispatch = useDispatch();
  const { vendorData, loading, error } = useSelector(
    (state) => state.dashboard
  );
  const user = useSelector((state) => state.auth.user);
  const vendorId = user?.vendor_id;
  const vendorBookings = useSelector((state) => state?.Invoice?.vendorInvoice?.data);

 const totalVendorBookingCharge = useMemo(() => {
    if (!vendorBookings || !Array.isArray(vendorBookings)) return 0;
    
    return vendorBookings.reduce((total, booking) => {
      return total + (booking.totalVendorBookingCharge || 0);
    }, 0);
  }, [vendorBookings]);
 
  const totalBookingCharge = useMemo(() => {
    if (!vendorBookings || !Array.isArray(vendorBookings)) return 0;
    
    return vendorBookings.reduce((total, booking) => {
      return total + (booking.totalBookingCharge || 0);
    }, 0);
  }, [vendorBookings]);
 
  useEffect(() => {
    dispatch(fetchVendorDashboardDataRequest());
    dispatch(
      fetchVendorInvoicesRequest({
        pagination_required: false,
        vendor_id: vendorId,
      })
    );
  }, [dispatch]);

  const monthLabels = vendorData?.monthlyRevenue?.map((item) => item.name) || [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const monthlyRevenueValues =
    vendorData?.monthlyRevenue?.map((item) => item.total) || Array(12).fill(0);

  const revenueChartData = {
    labels: monthLabels,
    datasets: [
      {
        label: "Total Revenue",
        data: monthlyRevenueValues,
        borderColor: "#ed6c02",
        backgroundColor: "rgba(237, 108, 2, 0.1)",
        pointBackgroundColor: [
          "#525252",
          "#ed6c02",
          "#525252",
          "#ed6c02",
          "#525252",
          "#ed6c02",
          "#525252",
          "#ed6c02",
          "#525252",
          "#ed6c02",
          "#525252",
          "#ed6c02",
        ],
        pointBorderColor: "#fff",
        pointRadius: 6,
        pointHoverRadius: 8,
        tension: 0.4,
      },
    ],
  };

  const statisticsData = [
    {
      metric: "Total Bookings",
      value: vendorData?.count?.totalBookingCount || 0,
    },
    {
      metric: "Completed Bookings",
      value: vendorData?.count?.totalCompletedBookingCount || 0,
    },
    {
      metric: "Cancelled Bookings",
      value: vendorData?.count?.totalCancelBookingCount || 0,
    },
  ];

  return (
    <Box className="admin-panel-box">
      <Box>
        <Grid container spacing={2} className="vendor-metrics">
          <Grid item xs={12} sm={6} md={4}>
            <Card className="metric-card">
              <CardContent>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  className="metric-title"
                >
                  Total Bookings
                </Typography>
                <Typography variant="h4" className="metric-value-users">
                  {vendorData?.count?.totalBookingCount || 0}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Confirmed:{" "}
                  {vendorData?.count?.totalCompletedBookingCount || 0},
                  Canceled: {vendorData?.count?.totalCancelBookingCount || 0}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Divider className="divider-line" />

          <Grid item xs={12} sm={6} md={4}>
            <Card className="metric-card">
              <CardContent>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  className="metric-title"
                >
                  Total Booking Charge
                </Typography>
                <Typography variant="h4" className="metric-value-revenue">
                  ₹ {totalBookingCharge.toFixed(2)}
                </Typography>

                <Typography variant="body2" color="textSecondary">
                  Total Vendor Booking Charge : ₹{" "}
                  {Number(totalVendorBookingCharge || 0).toFixed(
                    2
                  )}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Card className="metric-card">
              <CardContent>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  className="metric-title"
                >
                  Payments
                </Typography>
                <Typography variant="h4" className="metric-value-payments">
                  {vendorData?.count?.totalBookingCount || 0}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Refunds: {vendorData?.count?.totalCancelBookingCount || 0}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Divider className="divider-line" />

      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Card className="vendor-dashboard-card">
            <CardContent className="vendor-dashboard-card-content">
              <Box className="vendor-dashboard-header">
                <Typography variant="h6" className="vendor-dashboard-title">
                  Monthly Revenue
                </Typography>
              </Box>
              <Box
                className="vendor-dashboard-chart-container"
                style={{ height: "300px" }}
              >
                <Line
                  data={revenueChartData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        display: true,
                        position: "top",
                      },
                      tooltip: {
                        callbacks: {
                          label: function (context) {
                            return `₹ ${context.parsed.y.toLocaleString()}`;
                          },
                        },
                      },
                    },
                    scales: {
                      x: {
                        grid: { display: false },
                      },
                      y: {
                        beginAtZero: true,
                        ticks: {
                          callback: (value) => `₹${value.toLocaleString()}`,
                        },
                      },
                    },
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Divider className="divider-line" />

      <CustomerManagementList />

      <Divider className="divider-line" />

      <Typography variant="h5" gutterBottom>
        Statistics Reports
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Metric</TableCell>
            <TableCell align="center">Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {statisticsData.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.metric}</TableCell>
              <TableCell align="center">{row.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};
export default VendorDashBoard;
